import Icon from '../components/Icon.vue'

Icon.register({
  leaf: {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M546.2 9.7c19 42.4 29.8 94.4 29.8 144.6 0 172.4-110.5 313.2-267.5 324.6-80.9 8.6-142.5-33.3-174.9-77.2-51 42.7-70.4 87-71.9 90.6-6.8 16.2-25.4 24.1-41.8 17.3-16.3-6.7-24.1-25.3-17.5-41.6 23.6-57.9 130.2-212 381.6-212 8.8 0 16-7.2 16-16s-7.2-16-16-16c-130.6 0-222.7 38.8-286.5 84.5-0.7-6.8-1.5-13.5-1.5-20.5 0-106 86-192 192-192h80c63.4 0 118.9-33.6 149.9-87.5 6.7-11.8 22.7-11.3 28.3 1.2z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/leaf.js
// module id = 1515
// module chunks = 0